'use client';

import type { Team } from '@baseball-near-you/prisma';
import {
  Button,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@baseball-near-you/ui';
import { useTeams } from '@bb/lib/hooks/useTeams';
import { useState } from 'react';
import { Step } from '../TeamSelectionModal';
import { DialogTeamSelectionSearch } from './DialogTeamSelectionSearch';

export function TeamSelectionStep({
  hideCantFindTeam,
  specificTeam,
  setSelectedTeam,
  selectedTeam,
  ...props
}: {
  selectedTeamSlug?: string | null;
  specificTeam?: Team | null;
  setSelectedTeam: (team: Team | null) => void;
  selectedTeam?: Team | null;
  setStep: (step: Step) => void;
  hideCantFindTeam?: boolean;
  noResultsNode?: React.ReactNode;
}) {
  const [search, setSearch] = useState<string | null>(null);
  const [cantFindTeam, setCantFindTeam] = useState(false);
  const { teams } = useTeams({ search });
  console.log('teams', teams);

  return !cantFindTeam ? (
    <DialogTeamSelectionSearch
      setSearch={setSearch}
      setSelectedTeam={setSelectedTeam}
      setCantFindTeam={setCantFindTeam}
      search={search}
      specificTeam={specificTeam}
      selectedTeam={selectedTeam}
      selectedTeamSlug={props.selectedTeamSlug}
      onTeamSelect={() => props.setStep(Step.Background)}
      hideCantFindTeam={hideCantFindTeam}
      noResultsNode={props.noResultsNode}
    />
  ) : (
    <>
      <DialogHeader>
        <DialogTitle>Request to add new team</DialogTitle>
      </DialogHeader>

      <div className="rounded-md p-4">
        <p>
          Please email{' '}
          <a
            className="text-blue-500 underline"
            href="mailto:zach@baseballnearyou.com?subject=NEW TEAM REQUEST&body=Your name:  %0D%0A%0D%0ATeam name: %0D%0A%0D%0ALocation: %0D%0A%0D%0AYour role with the team: %0D%0A%0D%0ABest way to contact: %0D%0A%0D%0ASocial Media (Facebook, Twitter (X), Instagram, etc.):"
          >
            zach@baseballnearyou.com
          </a>{' '}
          to submit a request to add your team to our app.
        </p>
      </div>
      <DialogFooter>
        <Button
          className="w-min whitespace-nowrap"
          onClick={() => {
            setCantFindTeam(false);
            props.setStep(Step.Onboarding);
          }}
        >
          Continue
        </Button>
      </DialogFooter>
    </>
  );
}
